// Bridge between GameMediaPreview and non-React callers (GamepadProvider).
// State via DOM attr `dialog[data-video-playing]`; revert via custom event.
export const MEDIA_PREVIEW_REVERT_EVENT = "media-preview:revert";

export const isMediaPreviewVideoPlaying = (): boolean =>
  !!document.querySelector('dialog[data-video-playing="true"]');

export const requestMediaPreviewRevert = (): void => {
  window.dispatchEvent(new CustomEvent(MEDIA_PREVIEW_REVERT_EVENT));
};
